import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import "react-responsive-modal/styles.css";
import { RouterProvider } from "react-router";
import "./index.css";
import { store } from "./redux/configureStore";
import router from "./router/router";

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GOOGLE_TAG_ID,
};

const App = () => {
  TagManager.initialize(tagManagerArgs);
  ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_ID);

  return (
    <Provider store={store}>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </Provider>
  );
};

export default App;
